export default __webpack_public_path__ + "static/media/3.1d2e1280.png";